
import PaneTitle from '@/components/panes/PaneTitle.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ParadigmValues',
  props: {
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      signs: {
        below: `${decodeURI('%3C')}`,
        belowOrEqual: `${decodeURI('%E2%89%A4')}`,
        aboveOrEqual: `${decodeURI('%E2%89%A5')}`,
      },
    }
  },
  components: { PaneTitle },
})
